module.exports = __webpack_public_path__ + "static/media/failureMechanism.4d0751cb.png";